import React from "react";

const ImageBlock = ({ data , className}) => {
    const style = data.height
        ? {
              minHeight: data.height.minHeight
                  ? `${data.height.minHeight}px`
                  : null,

              height: data.height.height
                  ? `${data.height.height}px`
                  : null,
          }
        : {};
    return (
        <img src={data.url} className={`w-full ${className ?? ''}`} style={style} alt={data.alt} />
    );
};

const ImageBlockContain = ({ data }) => {
    const style = data.height
        ? {
              minHeight: data.height.minHeight
                  ? `${data.height.minHeight}px`
                  : null,
          }
        : {};
    return (
        <img src={data.url} className={`object-contain w-${data.width.width}`} style={style} alt={data.alt} />
    );
};

export {
    ImageBlockContain
}

export default ImageBlock;
